// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3107":"3bba707dcfce85f5","5152":"10ff0686291ca0ce"}[chunkId] + ".js";
};